// DRAWER MENU MOBILE
class MobileDrawer extends HTMLElement {
    constructor(){
        super()
        this.isOpen = false
        this.triggerListener()
        this.setTop()
        this.showAndHideLevel()
    }

    connectedCallback() {
        this.setAttribute('aria-hidden', 'true')
        this.addEventListener('keydown', this.handleKeyDown)
    }
    
    close(){
        this.classList.remove('mobile-drawer--is-open')
        this.setAttribute('aria-hidden', 'true')
        document.documentElement.classList.remove('js-mobile-drawer--is-open')
        this.isOpen = false
    }
    
    
    open(){
        this.classList.add('mobile-drawer--is-open')
        this.removeAttribute('aria-hidden')
        document.documentElement.classList.add('js-mobile-drawer--is-open')
        this.isOpen = true
    }

    triggerListener(){
        const trigger = document.querySelector('.js-mobile-drawer-trigger');
        if(trigger) {
            const firstTabInMobileMenu = document.querySelector('.mobile-draw__items--btn:first-child');
            const lastTabInMobileMenu = document.querySelector('.mobile-draw__items--btn:last-child');
            const mobileMenuItems = document.querySelectorAll('[href*="mobile-sub-t-"]');
            const lastChildInLastMenuItemSubMenu = document.querySelector('[role="tabpanel"]:first-child li:last-child .mobile-nav__sub-t__item:last-child a');
            const lastMobileMenuItemSecondMenu = document.querySelector('[role="tabpanel"]:last-child li:last-child a');
            /** Grabs the last mobile menu item through a regex search */
            let highestNumber = 0;
            let lastMobileMenuItem = null;
            mobileMenuItems.forEach((item) => {
                const href = item.getAttribute('href');
                const match = href.match(/t-(\d+)/);
                if (match) {
                    const number = parseInt(match[1]);
                    if (number > highestNumber) {
                        highestNumber = number;
                        lastMobileMenuItem = item;
                    }
                }
            });
            /**
             *  Manages focus order, since the mobile drawer is not a sibling of the trigger element 
             */
            trigger.addEventListener('keydown', (event) => {
                if (event.key === "Escape" || event.key === " ") {
                    event.preventDefault()
                    trigger.ariaExpanded = false;
                    this.close()
                }
                if (this.isOpen && event.key === "Tab" && !event.shiftKey) {
                    event.preventDefault();
                    firstTabInMobileMenu.focus();
                } else if (this.isOpen && event.key === "Tab" && event.shiftKey && typeof lastMobileMenuItem !== null) {
                    event.preventDefault();
                    if (firstTabInMobileMenu.classList.contains('is-open')) {
                        console.log(lastMobileMenuItem)
                        if (lastMobileMenuItem.ariaExpanded === "true") {
                            lastChildInLastMenuItemSubMenu.focus();
                        } else {
                            lastMobileMenuItem.focus();
                        }
                    } else if (lastTabInMobileMenu.classList.contains('is-open')) {
                        lastMobileMenuItemSecondMenu.focus();
                    }
                }
            })
            firstTabInMobileMenu.addEventListener('keydown', (event) => {
                if (this.isOpen && event.key === "Tab" && event.shiftKey) {
                    event.preventDefault();
                    trigger.focus();
                }
            });
            if (lastMobileMenuItem) {
                const firstChildInLastMenuItemSubMenu = document.querySelector('.mobile-nav__sub-t__link:first-child');
                lastMobileMenuItem.addEventListener('keydown', (event) => {
                    if (this.isOpen && event.key === "Tab" && !event.shiftKey) {
                        if (lastMobileMenuItem.ariaExpanded === "true") {
                            firstChildInLastMenuItemSubMenu.focus();
                        } else {
                            event.preventDefault();
                            trigger.focus();
                        }
                    }
                });
                lastChildInLastMenuItemSubMenu.addEventListener('keydown', (event) => {
                    if (this.isOpen && event.key === "Tab" && !event.shiftKey) {
                        event.preventDefault();
                        trigger.focus();
                    }
                });
                lastMobileMenuItemSecondMenu.addEventListener('keydown', (event) => {
                    if (this.isOpen && event.key === "Tab" && !event.shiftKey) {
                        event.preventDefault();
                        trigger.focus();
                    }
                });
            }
            /** Toggles visibility of the mobile drawer */
            trigger.addEventListener('click', (evt) => {
                evt.preventDefault()
                evt.stopPropagation()

                if(this.isOpen) {
                    this.close()
                    trigger.setAttribute('aria-expanded', 'false')
                    return
                }
                
                this.open()
                this.setTop()
                trigger.setAttribute('aria-expanded', 'true')
            })
        }
    }

    setTop(){
        const stickyHeader = document.querySelector('header#top');
        const header = document.querySelector('#shopify-section-header');
        const headerIsSticky = stickyHeader && stickyHeader.classList.contains('site-header--stuck');

        if(header) {
            const headerHeight = headerIsSticky ? stickyHeader.clientHeight : header.clientHeight;

            this.style.top = `${headerHeight + 1}px`;
        }
    }

    showAndHideLevel() {
        const btns = document.querySelectorAll('.mobile-draw__items--btn');
        const btnsParent = document.querySelector('.mobile-draw__items--parent');
        if(btns.length > 0) {
            btns.forEach(btn => {
                btn.addEventListener('click', (evt) => {
                    btns.forEach(btn => {
                        btn.classList.remove('is-open');
                        btn.ariaSelected = 'false';
                    });
                    btn.addEventListener('click', changeTabs);
                    btn.classList.add('is-open')
                    btn.ariaSelected = 'true'
                    const dataParent            = btn.dataset.parent
                    const allSecondLevels       = document.querySelectorAll('.mobile-nav__sub')
                    const currentSecondLevel    = document.querySelector(`.mobile-nav__sub[data-parent="${dataParent}"]`)

                    if(allSecondLevels.length > 0) allSecondLevels.forEach(item => item.classList.remove('is-open'))
                    currentSecondLevel.classList.add('is-open')
                })
                /**
                 * JavaScript to control mobile menu buttons as tabs for a11y compliance
                 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
                 */
                let currentTabFocus = 0;
                btnsParent.addEventListener('keydown', (event) => {
                    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                        btns[currentTabFocus].setAttribute('tabindex', -1);
                        if (event.key === "ArrowRight") {
                            event.preventDefault(); 
                            currentTabFocus++;
                            if (currentTabFocus >= btns.length) {
                                currentTabFocus = 0;
                            }
                        }
                        else if (event.key === 'ArrowLeft') {
                            event.preventDefault(); 
                            currentTabFocus--;
                            if (currentTabFocus < 0) {
                                currentTabFocus = btns.length - 1;
                            }
                        }
                        btns[currentTabFocus].setAttribute('tabindex', 0);
                        btns[currentTabFocus].focus();
                    }
                });

                function changeTabs(event) {
                    const target = event.target;
                    const tabpanels = document.querySelectorAll('.mobile-draw__nav [role="tabpanel"]');
                    const btnsParent = document.querySelector('.mobile-draw__items--parent');

                    // If the target button is already selected, return early
                    // To prevent tabpanel from being hidden
                    if (target.getAttribute('aria-selected') === 'true') {
                        return;
                    }

                    btnsParent
                        .querySelectorAll('[aria-selected="true"]')
                        .forEach((tab) => tab.setAttribute("aria-selected", false));
                    target.setAttribute('aria-selected', true);
                    tabpanels.forEach((tabpanel) => tabpanel.setAttribute("hidden", true));
                    document
                        .querySelector('[role="tab"][aria-selected="true"]')
                        .removeAttribute('hidden');
                }
            })
        }
    }

    handleKeyDown (event) {
        const trigger = document.querySelector('.js-mobile-drawer-trigger');
        if (event.key === "Escape") {
            this.close()
            trigger.ariaExpanded = false;
            trigger.focus()
        }
    }
}
    
customElements.define('mobile-drawer', MobileDrawer)